"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var glightbox_1 = __importDefault(require("glightbox"));
require("../vendor/lite-youtube-embed/src/lite-yt-embed");
var analyticsEvents_1 = require("common/analyticsEvents");
// Components
require("./components/lazy");
require("./phone-mask");
require("./components/buy-button");
require("./details-anchor");
require("./components/translate");
require("./components/cookies-popup");
require("./components/reviews");
require("./components/lazyLoadCaptchas");
require("./components/login");
require("./components/callback-dialog");
require("./components/bitrix-forms");
// import './tabgroup';
require("./gallery");
require("./catalog-section-list");
// import './lightgallery';
require("./slick");
require("./drawer");
require("./components/banner");
require("./index");
// Pages
require("./pages/landing");
// Libs
// @ts-ignore
var tabbed_1 = require("./tabbed");
tabbed_1.tabbed('.js-tabbed');
analyticsEvents_1.analyticsEvents();
glightbox_1.default({ selector: '.glightbox' });
// Import all svg icons for spriting
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../svg-icons', true, /\.svg$/));
